// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Edit from '../_raw/ui/icon_edit.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Edit);
